export default __webpack_public_path__ + "static/media/Icons_youtube_copia.396e5969.svg";